import React from "react";

const LoadingIndicator = (loading) => {
  return <div className="loading-indicator"></div>;
};

export default LoadingIndicator;
